import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { applyTheme, getTheme } from './theme';
import './theme-pink.css';
import * as serviceWorker from './serviceWorker';

// The pink theme is a personal choice kept in this browser; apply it before the first paint.
applyTheme(getTheme());

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
